const isZodObject = (schema)=>schema?._def?.typeName === 'ZodObject';
const isZodArray = (schema)=>schema?._def?.typeName === 'ZodArray';
const isZodUnion = (schema)=>schema?._def?.typeName === 'ZodUnion';
const isZodIntersection = (schema)=>schema?._def?.typeName === 'ZodIntersection';
const isZodDiscriminatedUnion = (schema)=>schema?._def?.typeName === 'ZodDiscriminatedUnion';
const isZodMap = (schema)=>schema?._def?.typeName === 'ZodMap';
const isZodSet = (schema)=>schema?._def?.typeName === 'ZodSet';
const isZodRecord = (schema)=>schema?._def?.typeName === 'ZodRecord';
export { isZodArray, isZodDiscriminatedUnion, isZodIntersection, isZodMap, isZodObject, isZodRecord, isZodSet, isZodUnion };
